import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from "react-router-dom";

import { LoginLayout, PublicLayout, SignupLayout } from "../pages/Layout";
import {
  AppLinking,
  AppLinkingTokenLoader,
  Condiciones,
  EmailConfirmation,
  EmailConfirmationTokenLoader,
  EmailInactivation,
  EmailInactivationTokenLoader,
  Error,
  Login,
  PacienteEmailConfirmation,
  PacienteEmailConfirmationTokenLoader,
  PacientePasswordReset,
  PacientePasswordResetTokenLoader,
  PasswordReset,
  PasswordResetTokenLoader,
  Politicas,
  Signup,
} from "../pages";

const router = createBrowserRouter([
  {
    path: "",
  //   element: <Root/>,
    errorElement: <Error />,
    children: [
      {
        path: "",
        element: <LoginLayout />,
        children: [
          {
            path: "",
            element: <Login />,
          }
        ]
      },
      {
        path: "",
        element: <SignupLayout />,
        children: [
          {
            path: "/signup",
            element: <Signup />,
          }
        ]
      },
      {
        path: "",
        element: <PublicLayout />,
        children: [
          {
            path: "/politicas",
            element: <Politicas />,
          },
          {
            path: "/condiciones",
            element: <Condiciones />,
          },
          {
            path: "/email-confirmation/:token",
            element: <EmailConfirmation />,
            loader: EmailConfirmationTokenLoader,
          },
          {
            path: "/paciente-email-confirmation/:token",
            element: <PacienteEmailConfirmation />,
            loader: PacienteEmailConfirmationTokenLoader,
          },
          {
            path: "/password-reset/:token",
            element: <PasswordReset />,
            loader: PasswordResetTokenLoader,
          },
          {
            path: "/paciente-password-reset/:token",
            element: <PacientePasswordReset />,
            loader: PacientePasswordResetTokenLoader,
          },
          {
            path: "/email-inactivation/:token",
            element: <EmailInactivation />,
            loader: EmailInactivationTokenLoader,
          },
          {
            path: "/paciente-app-link/:token",
            element: <AppLinking />,
            loader: AppLinkingTokenLoader,
          },
        ]
      },
      {
        path: "/*",
        element: <Navigate to="" />,
      }
    ],
  },
]);

export const PublicRouter = () => {
  return (
    <>
      <RouterProvider router={router} />
    </>
  )
}
